import { useAPIQuery } from "../../../../hooks/useAPIQuery";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useMemo } from "react";
import ErrorRVMatrix from "./ErrorRVMatrix";
import { useForm } from "react-hook-form";

const RVMatrix = () => {
    const {
        register,
        handleSubmit,
        formState: { dirtyFields },
        reset,
    } = useForm();

    const { useFetch, useCreate } = useAPIQuery({
        key: "api/roles",
        endpoint: "/api/roles/",
    });

    const { data, isLoading, isFetching, isError } = useFetch({
        params: { action: "rv_matrix" },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { mutate, isPending } = useCreate({
        params: { action: "rv_matrix" },
        successMessageFromServer: true,
        errorMessageFromServer: true,
    });

    const columns = useMemo(() => {
        if (data) {
            return [
                {
                    accessor: "privilege_name",
                    header: "",
                    cell: (row) => (
                        <span className="text-secondary">
                            {row?.privilege_name}
                        </span>
                    ),
                },
                ...data?.data?.roles?.map((role) => ({
                    accessor: role?.role_name,
                    header: role?.role_name,
                    cell: (row) => {
                        const isDirty =
                            !!dirtyFields[`${role?.id}`]?.[`${row?.id}`]
                                ?.assigned;
                        return (
                            <input
                                type="checkbox"
                                defaultChecked={
                                    role?.privilege?.filter(
                                        (privilege) => privilege?.id === row?.id
                                    )?.length !== 0
                                        ? true
                                        : false
                                }
                                style={{
                                    accentColor: isDirty ? "red" : "",
                                }}
                                {...register(`${role?.id}.${row?.id}.assigned`)}
                            />
                        );
                    },
                })),
            ];
        }
        return [];
    }, [data, dirtyFields]);

    const extractDirtyFields = (dirtyFields, submitData) => {
        console.log(dirtyFields);
        console.log(submitData);
        let result = {};

        Object.keys(dirtyFields).forEach((roleId) => {
            dirtyFields[roleId].forEach((field, index) => {
                if (field !== null) {
                    if (!result[roleId]) result[roleId] = {};

                    result[roleId][index] = submitData?.[roleId]?.[index];
                }
            });
        });

        return result;
    };

    console.log(dirtyFields);

    const onSubmit = (data) => {
        const fields = extractDirtyFields(dirtyFields, data);
        const res = {
            bulk_upload: Object.keys(fields).map((role) => ({
                role_id: Number(role),
                privilege: Object.keys(fields?.[role])?.map((privilege) => ({
                    id: Number(privilege),
                    assigned: fields?.[role]?.[privilege]?.assigned,
                })),
            })),
        };

        mutate({ data: res });
    };

    if (isError) return <ErrorRVMatrix />;

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">RV Matrix</h3>
                    </div>
                </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="d-flex align-items-center justify-content-end">
                    <button
                        type="button"
                        className="btn btn-warning ms-auto me-3"
                        onClick={() => reset({})}
                    >
                        Reset
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={
                            isPending || Object.keys(dirtyFields).length === 0
                        }
                    >
                        {isPending ? "loading..." : "Update"}
                    </button>
                </div>
                <div className="table-responsive">
                    <Table
                        data={data?.data?.privileges ?? []}
                        columns={columns}
                        isLoading={isLoading || isFetching || isPending}
                        manualFilter={false}
                        pagination={false}
                        filterModal={false}
                        selectRows={false}
                        editRows={false}
                        deleteRows={false}
                    />
                </div>
            </form>
        </>
    );
};

export default RVMatrix;
